import { Box, Button, ButtonProps, Center, Container, Flex, Heading, Tab, TabList, TabPanel, TabPanels, Tabs, useDisclosure } from "@chakra-ui/react";
import { ReactElement, useEffect, useState } from "react";
import LogosTable from "components/table";
import Layout from "scenes/layouts";
import StoreOrderService from "services/store-order/store-order-service";
import { useNavigate } from "react-router-dom";
import LogosTablePagination from "components/table/table-pagination";
import { usePaginator } from "chakra-paginator";

const StoreOrderScene = (): ReactElement => {
    const navigate = useNavigate();
    const [tabIndex, setTabIndex] = useState<number>(0);
    const [orders, setOrders] = useState<any[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [totalOrder, setTotalOrder] = useState<number>(0);

    const {
        pagesQuantity,
        currentPage,
        setCurrentPage,
        pageSize,
        setPageSize,
        offset
    } = usePaginator({
        total: totalOrder,
        initialState: {
            pageSize: 30,
            currentPage: 1
        }
    });

    const generateStatusByTabIndex = (tabIndex: number) => {
        let status = 0;
        switch (tabIndex) {
            case 0:
                status = 0;
                break;
            case 1:
                status = 10;
                break;
            case 2:
                status = 30;
                break;
            case 3:
                status = 40;
                break;
            case 4:
                status = 50;
                break;
            case 5:
            default:
                status = 50;
                break;
        }
        return status;
    };

    useEffect(() => {
        setIsLoading(true);
        let status = generateStatusByTabIndex(tabIndex);
        let skipCount = ((currentPage - 1) * pageSize);

        StoreOrderService.GetAll(status, skipCount, pageSize, '').then((res: any) => {
            if (res.result) {
                setOrders(res.result.items);
                setTotalOrder(res.result.totalCount);
            }
        }).finally(() => {
            setIsLoading(false);
        });
    }, [tabIndex, currentPage]);

    const handleClickRow = (order: any) => {
        window.open(`/storeorders/${order.id}`);
    };

    const handlePageChange = (nextPage: number) => {
        setCurrentPage(nextPage);
    };

    const orderTable = () => {
        return (
            <>
                <LogosTable
                    headers={[{ label: 'No. Pesanan' }, { label: 'Tanggal' }, { label: 'Customer' }, { label: 'Jumlah Produk' }, { label: 'Total', isNumeric: true }, { label: 'Metode Pemb.' }, { label: 'Status' }]}
                    rows={[{ propertyName: 'orderNumber' }, { propertyName: 'transactionDate', isDatetime: true }, { propertyName: 'shipment.customerName' }, { propertyName: 'totalQuantity' }, { propertyName: 'netTotal', isNumeric: true }, { propertyName: 'paymentMethodString' }, { propertyName: 'statusString' }]}
                    data={orders}
                    onRowClick={handleClickRow}
                />
                <LogosTablePagination currentPage={currentPage} pagesQuantity={pagesQuantity} handlePageChange={handlePageChange} />
            </>
        );
    }

    return (
        <Layout>
            <Container maxWidth={"8xl"} mt={2} mb={5}>
                <Box>
                    <Heading fontSize={'3xl'} fontWeight={"extrabold"}>Store Orders</Heading>
                </Box>
                <Box mt={6}>
                    <Tabs isFitted defaultIndex={tabIndex} index={tabIndex} onChange={(index) => setTabIndex(index)}>
                        <TabList overflowX={'auto'}>
                            <Tab>Semua</Tab>
                            <Tab>Belum Bayar</Tab>
                            <Tab>Dikemas</Tab>
                            <Tab>Dikirim</Tab>
                            <Tab>Selesai</Tab>
                            <Tab>Dibatalkan</Tab>
                        </TabList>
                        {
                            isLoading &&
                            <Box>Loading...</Box>
                        }
                        {
                            !isLoading &&
                            <TabPanels>
                                <TabPanel px={0} pt={8}>{orderTable()}</TabPanel>
                                <TabPanel px={0} pt={8}>{orderTable()}</TabPanel>
                                <TabPanel px={0} pt={8}>{orderTable()}</TabPanel>
                                <TabPanel px={0} pt={8}>{orderTable()}</TabPanel>
                                <TabPanel px={0} pt={8}>{orderTable()}</TabPanel>
                                <TabPanel px={0} pt={8}>{orderTable()}</TabPanel>
                            </TabPanels>
                        }
                    </Tabs>
                </Box>
            </Container>
        </Layout >
    );
};

export default StoreOrderScene;